export const USER = "USER";

export const updateUser = (user) => {
  return {
    type: USER,
    payload: user,
  };
};
